import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import Rest from '../../../Server/Rest';
import config from '../../../settings/config';
import user from '../../../settings/user';
import { STATUS_REQUEST } from '../../../constants/statuses';

const FilterFrom = () => {
  const [filterFrom, setFilterFrom] = useState<Date>();
  const [saveStatus, setSaveStatus] = useState<string | null>(null);

  useEffect(() => {
    if (user.config() && user.config().filter_from) {
      setFilterFrom(new Date(user.config().filter_from));
    }
  }, []);

  const handleChangeDate = (date: Date) => {
    setFilterFrom(date);
  };

  const saveFilterFrom = (e: any) => {
    e.preventDefault();

    setSaveStatus(STATUS_REQUEST.PENDING);

    Rest.peticionConfig(`${config.api_url}/config`, {
      method: 'PUT',
      body: JSON.stringify({
        params: {
          filter_from: filterFrom,
        },
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.result) {
          const config = JSON.parse(localStorage.getItem('Config') as string);
          localStorage.setItem(
            'Config',
            JSON.stringify({
              ...config,
              filter_from:
                filterFrom instanceof Date ? filterFrom.toISOString() : '',
            })
          );
          setSaveStatus(STATUS_REQUEST.SUCCESS);
        } else {
          setSaveStatus(STATUS_REQUEST.ERROR);
          alert(
            'Lo sentimos, no se puedo guardar la fecha de filtro. Itente más tarde.'
          );
        }
      })
      .finally(() => {
        setTimeout(() => {
          setSaveStatus(null);
        }, 3000);
      });
  };

  return (
    <form onSubmit={saveFilterFrom}>
      <label htmlFor="filter-from">Filtrar a partir de la fecha:</label>
      <div className="input-group mb-3">
        <DatePicker
          id="filter-from"
          aria-describedby="filter-from-help"
          className="form-control btn-block"
          locale="es"
          selected={filterFrom}
          dateFormat="dd/MM/yyyy"
          onChange={handleChangeDate}
          selectsStart
          showDisabledMonthNavigation
          shouldCloseOnSelect={true}
          placeholderText="--/--/----"
        />
      </div>

      <button
        type="submit"
        className="btn btn-primary"
        disabled={STATUS_REQUEST.PENDING === saveStatus}
      >
        {STATUS_REQUEST.PENDING === saveStatus ? 'Guardando...' : 'Guardar'}
      </button>

      <div
        className={`valid-feedback ${
          saveStatus === STATUS_REQUEST.SUCCESS ? 'd-block' : ''
        }`}
      >
        Fecha guardada correctamente
      </div>

      <div
        className={`invalid-feedback ${
          saveStatus === STATUS_REQUEST.ERROR ? 'd-block' : ''
        }`}
      >
        No se pudo guardar la fecha
      </div>
    </form>
  );
};

export default FilterFrom;
